<template>
  <component
    :is="stepComponent"
    :data-completed="hiring"
    :has-error="hasError"
    :loading-password="loadingPassword"
    @go-to-next-step="goToNextStep"
    @has-error="hasError = $event"
  />
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router/composables';
import { Hiring, hiringPaidCustody } from '../../services/paid-custody';
import { ObjectiveBuilderComponents, EPaidCustodySteps } from './helpers';
import { ref, computed } from 'vue';

const route = useRoute();
const hiring = ref<Hiring | null>(null);
const hasError = ref(false);
const loadingPassword = ref(false);

const currentStep = ref(
  route.params.status ? EPaidCustodySteps.CANCEL : EPaidCustodySteps.ACTIVE
);

const goToNextStep = async () => {
  const isSuccess = await fetchHiring();

  if (isSuccess) {
    currentStep.value = EPaidCustodySteps.COMPLETED;
  }
};

const fetchHiring = async () => {
  try {
    loadingPassword.value = true;
    hasError.value = false;

    const response = await hiringPaidCustody();

    hiring.value = response;

    return true;
  } catch (e) {
    hasError.value = true;

    return false;
  } finally {
    loadingPassword.value = false;
  }
};

const stepComponent = computed(
  () => ObjectiveBuilderComponents[currentStep.value]
);
</script>
